import {noop} from 'lodash';
import {createContext, ReactNode, useContext} from 'react';

import {EmailsInputState, OnChangeEmails} from '../../../common/editor/tokens/emailsInput';
import {OnboardingGuideRenderer} from '../../../onboarding/guide/onboardingGuidePopover';
import {OnboardingGuidesEnum} from '../../../onboarding/guide/onboardingGuideTypes';
import {AdminSetupGuideScreensEnum} from '../../../onboarding/setupGuide/setupGuideTypes';

export enum ContinueSetupTipsEnum {
  CONNECT_CHANNEL = 'connect_channel',
  INVITE_TEAMMATES = 'invite_teammates',
  KNOWS_SETUP_GUIDE_EXISTS_IN_P0 = 'knows_setup_guide_exists_in_p0',
}

export interface OnboardingModalContextProps {
  defaultAdminSetupGuideScreen: AdminSetupGuideScreensEnum;
  openAdminSetupGuide: () => void;
  openAdminSetupGuideDemoScreen: () => void;
  openAdminSetupGuideSetupScreen: () => void;
  closeAdminSetupGuide: () => void;

  isOnboardingChecklistModalOpen: boolean;
  setIsOnboardingChecklistModalOpen: (arg: boolean) => void;
  shouldOpenOnboardingChecklist: () => boolean;
  /** @returns Whether the onboarding checklist was opened. */
  maybeOpenOnboardingChecklist: () => boolean;

  requestedContinueSetupTip: ContinueSetupTipsEnum | undefined;
  requestContinueSetupTip(continueSetupTip: ContinueSetupTipsEnum): void;
  clearRequestedContinueSetupTip(): void;

  quickInvitePopoverEmails: EmailsInputState;
  setQuickInvitePopoverEmails: OnChangeEmails;
  quickInvitePopoverIsGlobalAdmin: boolean;
  setQuickInvitePopoverIsGlobalAdmin: (setIsGlobalAdmin: (isGlobalAdmin: boolean) => boolean) => void;

  onboardingGuide: OnboardingGuidesEnum | undefined;
  setOnboardingGuide: (onboardingGuide: OnboardingGuidesEnum | undefined) => void;
  renderOnboardingGuideTransition: (
    onboardingGuide: OnboardingGuidesEnum,
    render: OnboardingGuideRenderer,
  ) => ReactNode;
}

export const OnboardingModalContext = createContext<OnboardingModalContextProps>({
  defaultAdminSetupGuideScreen: AdminSetupGuideScreensEnum.DEFAULT,
  openAdminSetupGuide: noop,
  openAdminSetupGuideDemoScreen: noop,
  openAdminSetupGuideSetupScreen: noop,
  closeAdminSetupGuide: noop,
  isOnboardingChecklistModalOpen: false,
  setIsOnboardingChecklistModalOpen: noop,
  shouldOpenOnboardingChecklist: () => false,
  maybeOpenOnboardingChecklist: () => false,
  requestedContinueSetupTip: undefined,
  requestContinueSetupTip: noop,
  clearRequestedContinueSetupTip: noop,
  quickInvitePopoverEmails: {
    text: '',
    tokens: [],
  },
  setQuickInvitePopoverEmails: noop,
  quickInvitePopoverIsGlobalAdmin: false,
  setQuickInvitePopoverIsGlobalAdmin: noop,

  onboardingGuide: undefined,
  setOnboardingGuide: noop,
  renderOnboardingGuideTransition: () => null,
});

export function useOnboardingModalState() {
  return useContext(OnboardingModalContext);
}
